import { EditGridColumnType } from "../../../components/FinalMolGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const AdmissionCommitteeDataListConfig = {
  columns: [
    // {
    //   name: "Name",
    //   fieldName: "name",
    //   allowShort: false,
    //   allowEditColumn: true,
    //   editColumn: {
    //     editColType: EditGridColumnType.INPUT,
    //     placeholder: "Name",
    //     editColFieldName: "name",
    //     isDisable: false,
    //     colConfig: {
    //       isReadOnly: false,
    //     },
    //     editColValidation: [
    //       { type: "required", message: "Name is required." },
    //     ],
    //   },

    // },
    // {
    //   name: "Email Address",
    //   fieldName: "email",
    //   allowShort: false,
    //   allowEditColumn: true,
    //   editColumn: {
    //     editColType: EditGridColumnType.INPUT,
    //     placeholder: "Email Address",
    //     editColFieldName: "email",
    //     isDisable: false,
    //     colConfig: {
    //       isReadOnly: false,
    //     },
    //     editColValidation: [
    //       { type: "required", message: "Email Address is required." },
    //     ],
    //   },

    // },

    {
      name: "Name",
      fieldName: "name",
      allowShort: false,

    },

    {
      name: "Email Address",
      fieldName: "email",
      allowShort: false,

    },


    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  // editSettings: {
  //   buttons: {
  //     save: true,
  //     cancel: true
  //   }
  // },
  // allowEdit: true,
  isRowSelectable: false,
  handleRowDataUpdate: null,
  OnColumnChangeEdit: null,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
